<template>
	<div class="head-P">
    <div class="head-img">
      <slot></slot>
    </div>
    <div class="headPendant" :class="{'headPendant1': identity == 3}"></div>
  </div>
</template>

<script>
	export default {
		name: 'headPendant',
    props: {
      identity: {
        type: Number,
        default: 0
      }
    }
	}
</script>

<style scoped lang="scss">
  .head-P {
    position: relative;
    span {
      color: #FEA923;
      font-size: 0.11rem;
      position: absolute;
      right: -0.1rem;
      bottom: -0.07rem;
    }
  }
  .head-img {
    position: relative;
    z-index: 1;
    transform: scale(1);
  }
  .headPendant {
    position: absolute;
    width: 22%;
    height: 22%;
    right: 4%;
    bottom: 4%;
    z-index: 3;
    transform: scale(1.4);
  }
  .headPendant1 {
    background: url(/static/images/community/new-img/certtag.gif) no-repeat center;
    background-size: 100%;
  }
  .headPendant2 {
    /*background: url(/static/images/community/share@2x.png) no-repeat center;*/
    /*background-size: 100%;*/
  }
  .headPendant3 {
    /*background: url(/static/images/community/Thinktank@2x.png) no-repeat center;*/
    /*background-size: 100%;*/
  }
</style>



// WEBPACK FOOTER //
// src/components/common/headPendant.vue